import { PageEvent } from '@angular/material/paginator';

import { IGetApiResponseMeta } from './api-response.interface';

export interface IOrderData {
  boms ?:any[];
  id :number | string;
  name :string;
  orderNumber :string;
  quantity :number | string; // TODO: Revisit this type because of big decimal implementation
  rfqId :number | string;
  rfqTag ?:any[];
  sku :string;
  stocks :number | string; // TODO: Revisit this type because of big decimal implementation
  supplier :string;
  tag :any[];
  uom :string;
}

export interface IOrderActions {
  onRowClick :(data :any) => void;
  label :string;
  visible ?:Function;
}

export interface IOrderRowData {
  data :IOrderData[];
  meta :IGetApiResponseMeta;
}

export enum EOrderType {
  SALES_ORDER = 'sales_order',
  ASSEMBLY_ORDER = 'assembly_order',
  TRANSFER_ORDER = 'transfer_order',
}

export interface IOrderAgTableLineItemsPageEvent extends PageEvent {
  tag ?:string;
  supplier ?:string;
}
